import { render, staticRenderFns } from "./ab-load.vue?vue&type=template&id=1adc1d2e"
import script from "./ab-load.vue?vue&type=script&lang=js"
export * from "./ab-load.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports